export const MY_REPOSSESSIONS_BASIC = 'MY_REPOSSESSIONS_BASIC';
export const MY_SPOTTED_VEHICLES_BASIC = 'MY_SPOTTED_VEHICLES_BASIC';
export const REPOSSESSIONS_FOR_BRANCH = 'REPOSSESSIONS_FOR_BRANCH';
export const SPOTTED_VEHICLES_FOR_BRANCH = 'SPOTTED_VEHICLES_FOR_BRANCH';
export const UNITS_PENDING_REPOSSESSIONS_FOR_BRANCH = 'UNITS_PENDING_REPOSSESSIONS_FOR_BRANCH';
export const MY_SPOTTED_VEHICLES_LOADING = 'MY_SPOTTED_VEHICLES_LOADING';
export const MY_REPOSSESSIONS_LOADING = 'MY_REPOSSESSIONS_LOADING';
export const REPOSSESSIONS_FOR_BRANCH_LOADING = 'REPOSSESSIONS_FOR_BRANCH_LOADING';
export const SPOTTED_VEHICLES_FOR_BRANCH_LOADING = 'SPOTTED_VEHICLES_FOR_BRANCH_LOADING';
export const REPOSSESSION_HIT_LIST_FOR_BRANCH = 'REPOSSESSION_HIT_LIST_FOR_BRANCH';
export const RHL_ASSIGNED_TO_ME = 'RHL_ASSIGNED_TO_ME';
export const RHL_ASSIGNED_TO_ME_FULLFILLED = 'RHL_ASSIGNED_TO_ME/fulfilled';
export const RHL_ASSIGNED_TO_ME_LOADING = 'RHL_ASSIGNED_TO_ME_LOADING';
